export var DISABLED_ICON_COLOR = '#727476';
export var DISABLED_ICON_BUTTON_STYLE = {
    color: DISABLED_ICON_COLOR,
};
